module.exports = __webpack_public_path__ + "media/images/landing/illust/bg-hero-v2-mobile-98dcbfd32c554a4052c060cfe0443c29.png";